import { Capacitor } from '@capacitor/core';
import CookieNameSpace from '~/const/cookie';
import { configureTruckerBackgroundRunner } from '~/helpers/truckerBackgroundCache';
import { getTokenFromStorage } from '~/helpers/storage';

export default defineNuxtPlugin(async () => {
	if (!Capacitor.isNativePlatform()) return;

	const baseURL = String(useRuntimeConfig().public.baseURL || '').trim();
	try {
		const token = await getTokenFromStorage(CookieNameSpace.getAccessToken);
		await configureTruckerBackgroundRunner(baseURL, token);
	} catch (error) {
		console.error('Failed to configure trucker background refresh:', error);
	}
});
